import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Toolbar, Typography } from '@mui/material';

interface ResultDialogProps {
  open: boolean;
  onClose: () => void;
  message: string;
  title?: string;
}

const ResultDialog: React.FC<ResultDialogProps> = ({ open, onClose, message, title = 'Results' }) => (
  <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
    <Toolbar className="lbtoolbar">{title}</Toolbar>
    <DialogContent>
      <Typography sx={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}>{message}</Typography>
    </DialogContent>
    <DialogActions>
      <Button variant="text" onClick={onClose}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default ResultDialog;
